import { arrayOf, bool, exact, number, object, string } from "prop-types";

const baseProjectType = {
  id: string.isRequired,
  projectName: string,
  projectNumber: string.isRequired,
  projectType: string,
  productCategory: string,
  platformProject: bool.isRequired,
  intangibleAccountingStandard: bool.isRequired,
  productLine0: string,
  productLine1: string,
  productLine2: string,
  cosmosUnixTimestamp: number.isRequired,
};

/** @deprecated use TypeScript interface or type instead */
export const projectListType = exact({
  ...baseProjectType,
  description: string,
  projectNumberInt: number,
  isMigrated: bool,
  projectTypeLabel: string,
  status: string,
  statusLabel: string,
  productCategoryLabel: string,
  requestor: string,
  requestorFullName: string,
  requestorFullNameReversed: string,
  platformProject: bool,
  intangibleAccountingStandard: bool,
  productLineLabel0: string,
  productLineLabel1: string,
  productLineLabel2: string,
  projectLeaders: arrayOf(object),
  projectLeaderFullName: string,
  projectLeaderFullNameReversed: string,
  isDeleted: bool,
  companyCode: string,
  projectMembers: arrayOf(string).isRequired,
  stockKeepingUnits: arrayOf(string).isRequired,
  requiredIntakeApproverIds: arrayOf(string),
});

export const projectDashboardType = exact({
  ...baseProjectType,
  estimatedLaunchDate: string,
});
